import { Component, Input, Output, EventEmitter, HostBinding, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxButtonModule } from 'devextreme-angular';

export interface SegmentOption {
  label: string;
  value: number;
}

@Component({
    selector: 'app-gpd-segmented-switch',
    imports: [CommonModule, DxButtonModule],
    template: `
    <div class="toolbar-switch-container" [class.full-width]="fullWidth" [class.large]="size === 'large'">
      <dx-button
        *ngFor="let option of options"
        class="toggle-switch-option"
        [class.toggle-active]="option.value === value"
        [text]="option.label"
        (onClick)="select(option.value)"
      ></dx-button>
    </div>
  `,
    changeDetection: ChangeDetectionStrategy.Eager,
    styles: [`
    :host {
      display: inline-flex;
      align-self: center;
    }

    :host(.full-width) {
      display: flex;
      width: 100%;
    }

    .toolbar-switch-container {
      display: flex;
      align-items: center;
      padding: 4px;
      border-radius: 8px;
      background-color: #ededed;
    }

    .toolbar-switch-container.full-width {
      width: 100%;
    }

    .toggle-switch-option {
      background-color: transparent;
      border: none;
      border-radius: 8px;
      box-shadow: none;
    }

    .full-width .toggle-switch-option {
      flex: 1 0 0;
      min-width: 0;
    }

    .toggle-active {
      background-color: #ffffff;
    }

    .toggle-switch-option ::ng-deep .dx-button-content {
      padding: 4px 8px;
    }

    .large .toggle-switch-option ::ng-deep .dx-button-content {
      padding: 6px 12px;
    }

    .toggle-switch-option ::ng-deep .dx-button-text {
      font-size: 14px;
      font-weight: 500;
      color: #545454;
    }

    .toggle-active ::ng-deep .dx-button-text {
      color: #1a1a1a;
    }
  `]
})
export class GpdSegmentedSwitchComponent {
  @Input() options: SegmentOption[] = [];
  @Input() value: number = 0;
  /** Stretch the switch to fill its container, with equal-width tabs (form layouts). */
  @Input() fullWidth = false;
  /** 'large' = roomier tabs (about 40px tall) for dashboard section headers. */
  @Input() size: 'default' | 'large' = 'default';
  @Output() valueChange = new EventEmitter<number>();

  @HostBinding('class.full-width') get isFullWidth(): boolean {
    return this.fullWidth;
  }

  select(val: number): void {
    if (val !== this.value) {
      this.value = val;
      this.valueChange.emit(val);
    }
  }
}
